import script from "./SettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingPage.vue?vue&type=script&setup=true&lang=js"

import "./SettingPage.vue?vue&type=style&index=0&id=7f9dcd8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9dcd8a"]])

export default __exports__